<template>
<section class="single_page">
  <ol-map ref="ol-map" :lon="lon" :lat="lat" :mapid="mapid" :zoom="17" @lonlat="lonlat"></ol-map>
</section>
</template>

<script>

import OlMap from './OlMap'

export default {
  name: 'Cartographie',
  components: {
    OlMap
  },

  data() {
    return {
      mode: null,
      // lon: 5.041742,
      // lat: 47.322982,
      lon: null,
      lat: null,
      mapid: null
    }
  },

  created() {
    document.body.classList.add('map')
    document.body.scrollIntoView({
      behavior: 'smooth'
    })
    this.fetchDataNewMap()
  },

  destroyed() {
    document.body.classList.remove('map')
  },

  watch: {
    '$route': 'routeChanged'
  },

  methods: {
    routeChanged(newRoute, oldRoute) {
      // Changement avec composant actif
      this.fetchData(false)
    },
    fetchDataNewMap() {
      // Nouvelle Cartographie
      this.fetchData(true)
    },
    fetchData(newMap) {
      if (newMap === true) {
        // Nouvelle carte : reset
        this.$store.state.localisation.active = false
        this.$store.state.localisation.filter = null
      }

      this.lon = Number.parseFloat(this.$route.params.lon)
      this.lat = Number.parseFloat(this.$route.params.lat)
      this.mapid = Number.parseFloat(this.$route.params.mapid)
      this.mode = this.$route.params.mode

      if (this.mode === 'mesures') {
        this.$store.state.supports.show = false
        this.$store.state.mesures.show = true
        this.$store.state.simulations.show = false
      } else if (this.mode === 'stations') {
        this.$store.state.supports.show = true
        this.$store.state.mesures.show = false
        this.$store.state.simulations.show = false
      } else if (this.mode === 'simulations') {
        this.$store.state.supports.show = false
        this.$store.state.mesures.show = false
        this.$store.state.simulations.show = true
      } else if (this.mode === 'all') {
        this.$store.state.supports.show = true
        this.$store.state.mesures.show = true
        this.$store.state.simulations.show = false
      }
    },

    lonlat(lonlat) {
      if (this.$route.params.lon !== lonlat.lon.toString() && this.$route.params.lat !== lonlat.lat.toString()) {
        this.$router.push('/cartographie/lonlat/' + lonlat.lon + '/' + lonlat.lat)
      }
      if (lonlat.commune) {
        this.$store.state.localisation.filter = lonlat.commune
        this.$store.state.localisation.active = true
      }
    },

    // TODO déplacer ?
    zoomPlus() {
      this.$refs['ol-map'].zoomPlus()
    },
    zoomMinus() {
      this.$refs['ol-map'].zoomMinus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.single_page>>>form {
  background-color: white;
}

.single_page>>>.v-autocomplete {
  position: initial;
}

/*
.single_page >>> input {
  height: 38px;
}*/

.single_page>>>div.search-btn {
  width: 50px;
  height: 38px;
  /* background-color: #007abc; */
  background-image: url(../assets/img/icon-search.svg);
  background-size: 23px;
  background-position: center;
}

.single_page>>>div.search-btn:hover {
  background-color: #282828;
  -webkit-transition: background-color .5s linear;
  -o-transition: background-color .5s linear;
  transition: background-color .5s linear;
}
</style>
